export default __webpack_public_path__ + "static/media/note-add-new-create-icon.c0dd477a.svg";